import { useMutation, useQueryClient } from "@tanstack/react-query";

import { dismissRecommendation } from "services";

import { DISMISS_RECOMMENDATION, GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES } from "consts";

export const useDismissRecommendation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DISMISS_RECOMMENDATION],
    mutationFn: dismissRecommendation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES] });
    },
  });
};
